import { render, staticRenderFns } from "./addEmployer.vue?vue&type=template&id=f9c20aa6&scoped=true"
import script from "./addEmployer.vue?vue&type=script&lang=js"
export * from "./addEmployer.vue?vue&type=script&lang=js"
import style0 from "./addEmployer.vue?vue&type=style&index=0&id=f9c20aa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c20aa6",
  null
  
)

export default component.exports